import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import config from '../includes/ConfigFile.js';

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState(null);

  useEffect(() => {
    axios
      .get(`${config.BASE_URL}/api/company`) 
      .then((response) => {
        setCompany(response.data[0]);
      })
      .catch((error) => {
        console.error("Error fetching company details:", error);
      });
  }, []);

  return (
    <CompanyContext.Provider value={company}>{children}</CompanyContext.Provider>
  );
};

export const useCompany = () => useContext(CompanyContext);
